import secureLocalStorage from "react-secure-storage";
import BaseService from "../../../core/services/baseService";
import { getAPIBaseUrl } from "../../../environment/api";
import { PortalModule } from "../../../environment/apiEnvironment";
import { DeviceUrl } from "../../constants/apiConstants";
import qs from 'qs'

export default class DeviceService extends BaseService {
  constructor() {
    super(getAPIBaseUrl(PortalModule.DEVICE));
  } 

  // fetch device list for org
  async fetchDeviceList({ orgId, locations, deviceTypes, name, page, searchParam, isExport, organisationName, hierarchyNameList, deviceTypeNameList }): Promise<any> {
    let params :any = {}
    let endpoint
    if (locations) {
      params.locations = locations
    }
    if(deviceTypes) {
      params.deviceTypes = deviceTypes
    }
    if(name) {
      params.name = name
    }
    if(searchParam) {
      params.searchParam = searchParam
    }
    if(page) {
      params.page = page
    }
    if (organisationName) {
      params.organisationName = organisationName
    }
    if (hierarchyNameList) {
      params.hierarchyNameList = hierarchyNameList
    }
    if (deviceTypeNameList) {
      params.deviceTypeNameList = deviceTypeNameList
    }
    params.paranoid = false

    if(page) {
      endpoint = `${DeviceUrl.DEVICE}?organisationId=${orgId}&page=${page}`;
    } else {
      endpoint = `${DeviceUrl.DEVICE}?organisationId=${orgId}`;
    }

    if (isExport) {
      params.isExport = isExport;
      const response = await this.get(endpoint, {
        params: params,
        paramsSerializer: (params) => {
          return qs.stringify(params)
        },
        responseType: 'blob'
      });
      if (response && response.data) {
        return response.data
      }
      return null;
    }
    else {
      const response: any = await this.get(endpoint, {
        params: params,
        paramsSerializer: (params) => {
          return qs.stringify(params)
        },
      });
      return response?.data?.result?.message;
    }
    
  }

  async fetchPartNameList(orgId:string): Promise<any> {
    
    const endpoint = `${DeviceUrl.DEVICE_PARTNAMES}?organisationId=${orgId}`;
    const response: any = await this.get(endpoint);
    
    if (response?.data?.result) {
      return response.data.result; 
    }
    return [];
  }

  // async fetchDeviceListFilter(orgId:string,locations:any): Promise<any> {
  //   let params :any = {}
  //   let endpoint
  //   if (locations) {
  //     params.locations = locations
  //   }
  //   params.paranoid = true
  //     endpoint = `${DeviceUrl.DEVICE_FILTER}?organisationId=${orgId}`;
  //   const response: any = await this.get(endpoint, {
  //     params: params,
  //     paramsSerializer: (params) => {
  //       return qs.stringify(params)
  //     },
  //   });
  //   return response?.data?.result?.message;
  // }

  async fetchDeviceFilter(orgId:string,locations:any): Promise<any> {
    let params :any = {}
    if (locations) {
      params.locations = locations
    }
    params.paranoid = false
    let endpoint = `${DeviceUrl.DEVICE_FILTER}?organisationId=${orgId}`;
    const response: any = await this.get(endpoint, {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    });
    return response?.data?.result?.message;
  }

  async fetchDevicesAtHierarchy(locations:string): Promise<any> {
    let params :any = {}
    if (locations) {
      params.locations = [locations]
    }
    let endpoint = `${DeviceUrl.DEVICE}`;
    const response: any = await this.get(endpoint, {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    });
    return response?.data?.result?.message?.count;
  }

  async fetchDevicesHealthByOrgId(parameters): Promise<any> {
    let endpoint = `${DeviceUrl.DEVICE_HEALTH}`;
    let params : any = {}
    params.organisationId = parameters?.organizationId

    if(parameters?.isDashboard){
      params.isDashboard = parameters?.isDashboard
    } else {
      params.limit=250
    }

    const splitFunction = (sortBy) =>{
      let splittedArray = sortBy.split('-')
      params.sortBy = splittedArray[0]
      params.sortOrder = splittedArray[1]
    }

    if(parameters?.locations){
      params.locations = parameters?.locations
    }
    if(parameters?.products){
      params.productList = parameters?.products
    }
    if(parameters?.states){
      params.deviceStateList = parameters?.states
    }
    if(parameters?.page) {
      params.page = parameters?.page
    }
    if(parameters?.devices) {
      params.deviceList = parameters?.devices
    }
    if(parameters?.sortBy === undefined){
      splitFunction("state-desc")
    }
    else{
      splitFunction(parameters?.sortBy)
    }
    const response: any = await this.get(endpoint, {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      }
    });
    if(response?.data?.result)
      return response?.data?.result
    else 
      return null
  }

  async fetchDeviceTypeList(parameters:any): Promise<any>{
    let params : any = {}
    params.organizationId = parameters?.organizationId
    params.isOrgFilter = parameters?.isOrgFilter
    let endpoint = `${DeviceUrl.DEVICE_TYPE}`
    const response: any = await this.get(endpoint,{
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      }
    })
    if(parameters?.isOrgFilter){
      return response?.data?.result;
    }else{
      return response?.data?.result?.message?.rows;
    }
  }

  async fetchDeviceStates(): Promise<any> {
    let endpoint = `${DeviceUrl.DEVICE_STATES}`
    const response: any = await this.get(endpoint)
    return response?.data?.result;
  }

  async fetchDeviceComponents(parameters): Promise<any> {
    let endpoint = `${DeviceUrl.DEVICE_HEALTH}/${parameters.id}`;
    let params : any = {}

    const splitFunction = (sortBy) =>{
      let splittedArray = sortBy.split('-')
      params.sortBy = splittedArray[0]
      params.sortOrder = splittedArray[1]
    }

    if(parameters?.sortBy === undefined){
      splitFunction("severity-desc")
    }
    else{
      splitFunction(parameters?.sortBy)
    }
    let header : any = {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      }
    }
    if(parameters.cancelToken){
      header.cancelToken = parameters.cancelToken.token
    }
    const response: any = await this.get(endpoint, header)
    if(response?.data?.result)
      return response?.data?.result;
    else 
      return null
  }

  async fetchDeviceInfo(parameters): Promise<any> {
    let endpoint = `${DeviceUrl.DEVICE}/${parameters.id}`;
    const response: any = await this.get(endpoint)
    if(response?.data?.result)
      return response?.data?.result;
    else 
      return null
  }

  async updateDeviceInfo(parameters): Promise<any> {
    let endpoint = `${DeviceUrl.DEVICE}/${parameters.id}`;
    const response: any = await this.put(endpoint, parameters.device)
    if(response?.data?.result)
      return response?.data?.result;
    else 
      return null
  }

  async addDevice(parameters): Promise<any> {
    let endpoint = `${DeviceUrl.DEVICE}`;
    const response: any = await this.post(endpoint, parameters)
    if(response?.data?.result){
      return response?.data?.result
    } else if (response?.data?.error?.message) {
      return response?.data
    }
    else 
      return null
  }

  async deleteDevice(id): Promise<any> {
    let endpoint = `${DeviceUrl.DEVICE}/${id}`;
    const response: any = await this.delete(endpoint)
    if(response?.data?.result)
      return response?.data?.result;
    else 
      return null
  }

  async restoreDevice(id): Promise<any> {
    let endpoint = `${DeviceUrl.DEVICE}/restore/${id}`;
    const response: any = await this.post(endpoint)
    if(response?.data?.result)
      return response?.data?.result;
    else 
      return null
  }

  async fetchDeviceConfigViews(parameters: any): Promise<any> {
    const { deviceId, userName, availableViews } = parameters;
    let localeInfo:any = secureLocalStorage.getItem('locale')
    
    let params = {
      did: deviceId,
      username: userName,
      culture: localeInfo.culture,
    };
    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/views/`;

    if(availableViews){
      return availableViews;
    }
    const response: any = await this.get(endpoint, {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
    });
    if(response.status === 200) {
      if(response.data?.length > 1){
        response.data = response.data?.filter((view) => {
          if(view?.Name !== 'Raw')
            return view
        })
      }
      return response.data;
    }
    return null;
  }

  async fetchNodeContent(parameters: any): Promise<any> {
    const { deviceId, userName, viewName, Id, nodeIds, cachedNodeContent} = parameters;
    
    if(cachedNodeContent){
      const nodeIDS = nodeIds.split(';');
      const newNodeContent = cachedNodeContent.map((item: any, index: number) => {
        const newItem = {
          ...item,
          FullNodeId: nodeIDS[index],
          DeviceXmlVersions: {}
        }
        if (item?.ReadOnly && item.FullNodeId.match(/\.0\.[^.]+$/)) {
          newItem.ReadOnly = false
        }
        return newItem
      });
      return newNodeContent
    }

    // Split nodeIds and make parallel calls to avoid URL length issues
    return await this.fetchNodeContentParallel(parameters);
  }

  /**
   * Split nodeIds into chunks and make parallel API calls
   */
  async fetchNodeContentParallel(parameters: any): Promise<any> {
    const { deviceId, userName, viewName, Id, nodeIds } = parameters;
    const localeInfo: any = secureLocalStorage.getItem('locale');
    
    // Split nodeIds into array
    const nodeIdArray = nodeIds.split(';');
    
    // Define chunk size (adjust based on your server limits)
    const chunkSize = 10;
    const chunks = this.chunkArray(nodeIdArray, chunkSize);
    
    // Create parallel requests
    const promises = chunks.map(chunk => 
      this.fetchNodeContentChunk({
        deviceId,
        userName,
        viewName,
        Id,
        nodeIds: chunk.join(';'),
        localeInfo
      })
    );
    
    try {
      // Wait for all requests to complete
      const responses = await Promise.allSettled(promises);
      
      // Merge successful responses
      const mergedData = this.mergeNodeContentResponses(responses);
      
      return mergedData;
    } catch (error) {
      console.error('Error fetching node content:', error);
      throw error;
    }
  }

  /**
   * Fetch a chunk of node IDs
   */
  async fetchNodeContentChunk(params: any): Promise<any> {
    const { deviceId, userName, viewName, Id, nodeIds, localeInfo } = params;
    
    const requestParams = {
      did: deviceId,
      username: userName,
      culture: localeInfo?.culture,
      vn: viewName,
      nid: nodeIds
    };
    
    const endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/views/${Id}/nodes/all/`;

    const response: any = await this.get(endpoint, {
      params: requestParams,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
    });

    if (response.status === 200) {
      return response.data;
    }
    
    throw new Error(`API request failed with status: ${response.status}`);
  }

  /**
   * Split array into chunks
   */
  private chunkArray<T>(array: T[], chunkSize: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  }

  /**
   * Merge responses from multiple API calls
   */
  private mergeNodeContentResponses(responses: PromiseSettledResult<any>[]): any[] {
    const successfulResponses = responses
      .filter((result): result is PromiseFulfilledResult<any> => result.status === 'fulfilled')
      .map(result => result.value);

    if (successfulResponses.length === 0) {
      throw new Error('All node content API calls failed');
    }

    // Flatten all responses into a single array
    const allData = successfulResponses.flat();
    
    // Remove duplicates based on FullNodeId
    const uniqueNodeContent = Object.values(allData.reduce((acc: any, obj: any) => {
      acc[obj.FullNodeId] = obj;
      return acc;
    }, {}));

    return uniqueNodeContent;
  }

  async fetchConfigNodes(parameters: any): Promise<any> {
    const {
      deviceId,
      userName,
      viewName,
      Id,
      st,
      availableNode,
      signal,
    } = parameters;
   
    let localeInfo:any = secureLocalStorage.getItem('locale')
  
    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/views/${Id}/`;
    let url = `${endpoint}?did=${deviceId}&username=${userName}&culture=${localeInfo.culture}&vn=${viewName}`;

    if (st) {
      url = `${url}&st=${st}`;
    }

    if (availableNode) {
      return availableNode;
    }

    let response = null;
    if (signal) {
      response = await this.get(url, {
        cancelToken: signal?.token,
      });
    } else {
      response = await this.get(url);
    }

    if (response.status === 200) {
      return response.data;
    }
    return null;
  }

  async getConfigState(parameters: any): Promise<any> {
    const { deviceId, userName, prevState} = parameters;

    let params = {
      did: deviceId,
      username: userName,
    };
    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/status/`;

    const response: any = await this.get(endpoint, {
      params: params,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
    });
    
    if(response.status === 200) {
      const newResponse = response.data.Devices[0];
      if(newResponse?.ProcessingWorkItem){
        let latestdWorkItemTime: string
        newResponse?.WorkItems?.map((item: any) =>{
          if(!latestdWorkItemTime){
            latestdWorkItemTime = item?.CreatedTimestamp;
          } else if(latestdWorkItemTime < item?.CreatedTimestamp) {
            latestdWorkItemTime = item?.CreatedTimestamp;
          }
        })

        if(latestdWorkItemTime){
          newResponse.latestdWorkItemTime = latestdWorkItemTime
        }

      }
      return {
        response: newResponse,
        previousResponse: prevState
      }
    }
    return null;
  }

  async getDevicesStatus(parameters: any): Promise<any> {
    const { deviceIdList, userName } = parameters;

    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/status/?username=${userName}`;

    const response: any = await this.post(endpoint, { DeviceIds: deviceIdList });

    if (response.status === 200) {
      let deviceStatusList = response.data.Devices;

      let deviceStatuses = {};

      deviceIdList.forEach(async (currentDeviceId: string, index: number) => {
        const currentDeviceStatus = deviceStatusList[index];

        deviceStatuses = {
          ...deviceStatuses,
          [currentDeviceId]: currentDeviceStatus,
        };
      });

      return deviceStatuses;
    }
    return null;
  }


  async getConfiguration(parameters: any): Promise<any> {
    const { userName, deviceId } = parameters;

    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/work/request/?username=${userName}&did=${deviceId}`;

    const response: any = await this.put(endpoint);
    
    if(response.status == 200) {
      return "Success";
    }
    return null; 
  }

  async lockDeviceState(parameters: any): Promise<any> {
    const { userName, deviceId } = parameters;

    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/status/lock/?username=${userName}&did=${deviceId}`;

    const response: any = await this.put(endpoint);

    if(response.status === 200) {
      return response.data;
    }
    return null;  
  }

  async unLockDeviceState(parameters: any): Promise<any> {
    const { userName, deviceId } = parameters;
    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/status/unlock/?username=${userName}&did=${deviceId}`;

    const response: any = await this.put(endpoint);
    if(response.status === 200) {
      return response.data;
    }
    return null; 
  }

  async getConfigDevices(parameters: any): Promise<any> {
    const { userName, deviceId } = parameters;

    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/${deviceId}/copy/devices/?username=${userName}`;

    const response: any = await this.get(endpoint);
    
    if(response.status === 200) {
      return response.data;
    }
    return null;
  }

  async storeConfiguration(parameters: any): Promise<any> {

    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/work/save`;
    const response: any = await this.post(endpoint, parameters)
    
    if(response.status === 200) {
      return response.data;
    }
    return null;
  }

  async copyConfiguration(parameters: any): Promise<any> {
    const { userName, deviceId, payload } = parameters;

    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/${deviceId}/copy?username=${userName}`;
    const response: any = await this.post(endpoint, payload);

    if(response.status === 200) {
      return response.data;
    }
    return null;
  }

  async fetchDeviceAssets(parameters: any): Promise<any> {
    const { deviceId } = parameters;

    const payload = {
      allowedFileExtensions: "",
      serverDefaultAssetsRoot: "",
      serverDefaultAssetsLocation: ""
    }

    let endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/${deviceId}/assets`;

    const response: any = await this.post(endpoint, payload);

    if (response.status === 200) {
      let allDeviceFiles = {};
      for (let assest of response.data.files){
        let fileName = assest?.name.replace(/__customasset__\\/i, "");
        allDeviceFiles = {...allDeviceFiles, [fileName]:assest};
      }
      return allDeviceFiles;
    }
    return null;
  }

  async storeDeviceAssets(parameters: any): Promise<any> {
    const { payload, deviceId } = parameters;
    const endpoint = `${process.env.REACT_APP_DEVICE_CONFIG_URL}/${deviceId}/assets/upload`;
    const formData = new FormData();

    for (const [fileName, file] of Object.entries(payload) as [any, any]) {
      formData.append(fileName, file);
    }

    try {
      const response: any = await this.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if(response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.error('Error uploading assets:', error);
    }
    return null;
  }
}